module.exports = __webpack_public_path__ + "img/HD.2cb609b0.png";